import Module from '@/store/resource/common/module';
import Files from '@/store/resource/files';
import api from '@/factories/api';

let module = new Module(new Files());

module.add('state', {
  // Map of file ID to ingestion status { ingested: Boolean | null, supported: Boolean | null }
  ingestedFiles: {},
});

module.add('actions', {
  async loadIngestionStatus({ state, commit }, file_ids) {
    try {
      if (!file_ids || file_ids.length === 0) {
        return;
      }

      const CHUNK_SIZE = 25;
      const chunks = [];
      for (let i = 0; i < file_ids.length; i += CHUNK_SIZE) {
        chunks.push(file_ids.slice(i, i + CHUNK_SIZE));
      }

      await Promise.all(
        chunks.map(async (chunk) => {
          try {
            const res = await api().get('/files/ingestion_status', {
              params: { file_ids: chunk },
            });

            // Update ingestion status for each file
            (res?.files || []).forEach(({ file_id, ingested, supported }) => {
              commit('updateFileIngestionStatus', {
                fileId: file_id,
                ingested,
                supported,
              });
            });
          } catch (error) {
            console.error('Failed to load ingestion status chunk:', error);
          }
        })
      );
    } catch (error) {
      console.error('Failed to load ingestion status:', error);
    }
  },
});

module.add('getters', {
  byId: (state) => (id) => {
    return state.all.find((file) => file.id === id) || null;
  },
  fileIngestionStatus: (state) => (fileId) => {
    const status = state.ingestedFiles[fileId];
    if (!status) return { ingested: null, supported: null };
    return status;
  },
});

module.add('mutations', {
  updateFileIngestionStatus(state, { fileId, ingested, supported }) {
    state.ingestedFiles = {
      ...state.ingestedFiles,
      [fileId]: { ingested, supported },
    };
  },
  clearFileIngestionStatus(state) {
    state.ingestedFiles = {};
  },
});

export default module.create();
